import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../lib/api";
import { formatWIB } from "../../lib/datetime";

export default function AdminOrders() {
  const [orders, setOrders] = useState([]);
  const [paymentFilter, setPaymentFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    const qs = new URLSearchParams();
    if (paymentFilter) qs.set("payment_status", paymentFilter);
    if (statusFilter) qs.set("order_status", statusFilter);
    api.get(`/admin/orders?${qs.toString()}`).then((r) => setOrders(r.data.orders)).finally(() => setLoading(false));
  };

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [paymentFilter, statusFilter]);

  return (
    <div data-testid="admin-orders-page">
      <div className="font-mono text-xs uppercase tracking-widest text-[#00FF66]">// orders</div>
      <h1 className="font-heading font-bold text-3xl mt-1 mb-6">Orders</h1>

      <div className="flex flex-wrap gap-3 mb-6">
        <select data-testid="payment-filter" value={paymentFilter} onChange={(e) => setPaymentFilter(e.target.value)} className="input-term !w-auto">
          <option value="">all payments</option>
          <option value="pending">pending</option>
          <option value="paid">paid</option>
          <option value="failed">failed</option>
        </select>
        <select data-testid="status-filter" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="input-term !w-auto">
          <option value="">all statuses</option>
          <option value="pending">pending</option>
          <option value="processing">processing</option>
          <option value="completed">completed</option>
        </select>
      </div>

      {loading ? <div className="text-[#A1A1AA] font-mono">loading...</div> : (
        <div className="surface overflow-x-auto">
          <table className="w-full text-sm min-w-[800px]">
            <thead>
              <tr className="border-b border-[#1E293B] font-mono text-[11px] uppercase tracking-widest text-[#71717A]">
                <th className="text-left p-3">Order</th>
                <th className="text-left p-3">Email</th>
                <th className="text-right p-3">Total</th>
                <th className="text-left p-3">Payment</th>
                <th className="text-left p-3">Status</th>
                <th className="text-left p-3">Date</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 && <tr><td colSpan="6" className="p-6 text-center text-[#A1A1AA] font-mono">no orders</td></tr>}
              {orders.map((o) => (
                <tr key={o.id} className="border-b border-[#1E293B] last:border-0 hover:bg-white/[0.02] cursor-pointer" data-testid={`order-row-${o.id}`}>
                  <td className="p-3 font-mono text-[#00FF66]"><Link to={`/admin/orders/${o.id}`}>{o.id}</Link></td>
                  <td className="p-3">{o.email}</td>
                  <td className="p-3 text-right font-mono">${o.total.toFixed(2)}</td>
                  <td className="p-3"><span className="chip-mono">{o.payment_status}</span></td>
                  <td className="p-3"><span className="chip-mono">{o.order_status}</span></td>
                  <td className="p-3 font-mono text-xs text-[#A1A1AA]">{formatWIB(o.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
